export default {
  labels: {
    reply: 'Reactie van eigenaar',
  },
  form: {
    reply_text: {
      placeholder: 'Schrijf uw reactie...',
    },
  },
  buttons: {
    generate_reply: 'Reactie genereren',
    submit_reply: 'Reactie verzenden',
  },
  toasts: {
    failed_to_create_reply: 'Reactie aanmaken mislukt',
    failed_to_generate_ai_reply: 'AI-reactie genereren mislukt',
  },
};
